// extracted by mini-css-extract-plugin
export var button = "_dl-0";
export var icon = "_dl-1";